module.exports = __webpack_public_path__ + "img/7.cb7d2c4c.jpg";